import { REQUEST_CALENDAR_SUCCESS, REQUEST_CALENDAR_DATA_START} from '../constants/actionTypes';

const INITIAL_STATE = { appointments: {}, errors: null };

export default function calendarData(state=INITIAL_STATE, action) {
  
  switch(action.type) {
    case REQUEST_CALENDAR_SUCCESS:
      return { ...state, appointments: { ...action.payload.data, isLoading: false }, errors: null }
    default:
      return state;
  }
}
